<!-- src/app/shared/loading/loading.component.html -->
<div class="loading">{{ message }}</div>
